import {mapActions, mapGetters} from "vuex";

export default {
    components: {
        Header: () => import('@/components/header/index.vue'),
        leftBar: () => import('@/components/left-bar/index.vue'),
        TableOptions: () => import('@/components/table/options/index.vue'),
        Table: () => import('@/components/table/list/index.vue'),
    },
    data() {
        return {
            // Статичні визначення полів: перекладні підписи — labelKey,
            // сам `label` обчислюється в computed fields (залежить від локалі).
            fieldDefs: [
                {
                    key: 'id',
                    label: 'id',
                },
                {
                    key: 'sms_order_id',
                    label: 'order_id',
                },
                {
                    key: 'number_phone',
                    labelKey: 'smsList.phone',
                },
                {
                    key: 'mailing_message',
                    labelKey: 'smsList.message',
                },
                {
                    key: 'sms_balance',
                    labelKey: 'smsList.balance',
                },
                {
                    key: 'sms_created_at',
                    labelKey: 'smsList.sent',
                },
                {
                    key: 'sms_updated_at',
                    labelKey: 'smsList.updated',
                },
                {
                    key: 'state',
                    labelKey: 'smsList.state',
                },
                {
                    key: 'mailing_status',
                    labelKey: 'smsList.updated',
                },
            ],
            items: [],
            stateList: [
                {
                    key: 'DELIVRD',
                },
                {
                    key: 'EXPIRED',
                },
                {
                    key: 'DELETED',
                },
                {
                    key: 'UNDELIV',
                },
                {
                    key: 'REJECTD',
                },
                {
                    key: 'UNKNOWN',
                },
            ],
        }

    },
    computed: {
        fields() {
            return this.fieldDefs.map(field => field.labelKey
                ? { ...field, label: this.$t(field.labelKey) }
                : field);
        },
        ...mapGetters({
            menuHide: 'config/menuHide',
            smsList: 'templates/smsList',
        })
    },
    watch: {
        smsList(e) {
            this.items = [];
            e.data.map(item => {
                const status = item.delivery_status ? item.delivery_status : '<span style="color: red;">' + this.$t('smsList.no_status') + '</span>'
                let state = this.stateList.filter(itemState => itemState.key === status)
                state = state[0]
                const stateTitle = state ? this.$t('smsList.state_' + state.key) : this.$t('smsList.no_state')
                this.items.push({
                    id: item.id,
                    sms_order_id: item.order_id,
                    number_phone: item.phone,
                    mailing_message: item.message,
                    sms_balance: item.balance,
                    sms_created_at: this.$moment(item.created_at).format('YYYY.MM.DD  HH:mm:ss'),
                    sms_updated_at: this.$moment(item.updated_at).format('YYYY.MM.DD  HH:mm:ss'),
                    mailing_status: status,
                    state: state ? stateTitle : '<span style="color: red;">' + this.$t('smsList.no_state') + '</span>',
                    stateInfo: stateTitle,
                })
            })
        },
    },
    created() {
        this.getSmsList();
    },
    methods: {
        mailingReload(){
            this.getSmsList();
        },
        ...mapActions({
            getSmsList: 'templates/getSmsList'
        })
    }

}